import { render, staticRenderFns } from "./ApiTokenModal.vue?vue&type=template&id=1ba227f8&"
import script from "./ApiTokenModal.vue?vue&type=script&lang=js&"
export * from "./ApiTokenModal.vue?vue&type=script&lang=js&"
import style0 from "./ApiTokenModal.vue?vue&type=style&index=0&id=1ba227f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports